import { render } from "./Splash.vue?vue&type=template&id=0a48564f&scoped=true"
import script from "./Splash.vue?vue&type=script&lang=js"
export * from "./Splash.vue?vue&type=script&lang=js"

import "./Splash.vue?vue&type=style&index=0&id=0a48564f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a48564f"]])

export default __exports__